import {useAppDispatch, useAppSelector} from './useReduxHooks'
import * as actions from '../redux/reducers/classes/service'
import {
  ActivateClasseRequest,
  CreateClasseRequest,
  DeleteClasseRequest,
  FetchAllClassesRequest,
  FetchClasseByIdRequest,
  FetchClassesRequest,
  SuspendClasseRequest,
  UpdateClasseRequest,
} from '../redux/reducers/classes/types'

export default function useClasses() {
  const dispatch = useAppDispatch()
  const {classes, classeForEdit, listLoading, actionLoading, error, total, totalPages} =
    useAppSelector((state) => state.classes)

  const fetchClasses = (props: FetchClassesRequest) => {
    return dispatch(actions.fetchClasses(props))
  }

  const fetchAllClasses = (props: FetchAllClassesRequest) => {
    return dispatch(actions.fetchAllClasses(props))
  }

  const fetchClasseById = (props: FetchClasseByIdRequest) => {
    return dispatch(actions.fetchClasseById(props))
  }

  const createClasse = (props: CreateClasseRequest) => {
    return dispatch(actions.createClasse(props))
  }

  const updateClasse = (props: UpdateClasseRequest) => {
    return dispatch(actions.updateClasse(props))
  }

  const deleteClasse = (props: DeleteClasseRequest) => {
    return dispatch(actions.deleteClasse(props))
  }

  const suspendClasse = (props: SuspendClasseRequest) => {
    return dispatch(actions.suspendClasse(props))
  }

  const activateClasse = (props: ActivateClasseRequest) => {
    return dispatch(actions.activateClasse(props))
  }

  return {
    fetchAllClasses,
    classeForEdit,
    classes,
    listLoading,
    actionLoading,
    error,
    fetchClasses,
    fetchClasseById,
    createClasse,
    updateClasse,
    deleteClasse,
    suspendClasse,
    activateClasse,
    total,
    totalPages,
  }
}
